import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Birthdaypartyhoisting() {



    const cardData =
    {
        keyword: 'Birthday Party Hosting Morachi Chincholi Near Pune',
        heading: 'Anand Krushi Paryatan Kendra: Birthday Party Hosting Morachi Chincholi Near Pune',
        headingDescription: 'Set across 40 acres of lush greenery, this agri-tourism center is ideal for hosting birthday parties for all age groups. With activities like bullock cart and tractor rides, horse riding, boating, swimming, and rain dance, the celebration turns into a full day of fun. Kids and adults alike will love the puppet shows, magic shows, and traditional village games. Guests are treated to delicious homemade Maharashtrian meals and snacks, all in a relaxed, eco-friendly environment filled with scenic beauty and roaming peacocks. Whether it is a kids birthday or an adult celebration, Anand Krushi Paryatan Kendra offers an unforgettable experience for birthday party hosting Morachi Chincholi near Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Scenic Outdoor Birthday Lawns",
    "description": "Celebrate birthdays in wide-open farm lawns surrounded by trees, flowers, and chirping birds. These natural venues offer a refreshing change from crowded city halls, perfect for kids and adults alike."
  },
  {
    "title": "Traditional Welcome & Décor",
    "description": "Guests are welcomed with a tilak and jaggery ritual, followed by rustic decorations—balloons, rangoli, torans, and eco-friendly seating arrangements set under thatched pavilions or mango trees."
  },
  {
    "title": "Customizable Birthday Packages",
    "description": "Choose from half-day or full-day packages that include food, activities, rain dance, bullock cart rides, and fun games. Many agri-tourism centers offer budget-friendly birthday combos for all group sizes."
  },
  {
    "title": "Rain Dance & Splash Pool Fun",
    "description": "Beat the heat with a birthday party that includes rain dance zones, splash pools, and water slides. Great for summer birthdays and group celebrations with kids and young adults."
  },
  {
    "title": "Farm-Fresh Meals & Snacks",
    "description": "Enjoy Maharashtrian veg thalis, wood-fired snacks like bhakri-thecha, poha, and puran poli. Some hosts offer birthday cakes made from jaggery or traditional sweets for a rural twist on the dessert table."
  },
  {
    "title": "Petting Zoo & Animal Encounters",
    "description": "Kids can feed goats, watch ducks, visit hen coops, or pet calves. These supervised encounters bring joy and curiosity, making birthday events both entertaining and educational."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Add a fun rural element to your party with short bullock cart or tractor rides for children and families. Decorated carts add charm to birthday photo sessions and group fun."
  },
  {
    "title": "Games & Adventure Activities",
    "description": "Play traditional rural games like kho-kho, lagori, sack race, and gilli danda, or enjoy adventure setups with rope bridges, tire balancing, and mini obstacle courses—fun for all age groups."
  },
  {
    "title": "Evening Bonfire & Music",
    "description": "Host an evening party with bonfire, folk music, DJ beats or karaoke sessions. Dance, sing, and celebrate under the stars in a cozy, natural setting away from the city bustle."
  },
  {
    "title": "Overnight Stay for Guests",
    "description": "If you wish to extend the party into a mini vacation, book farm cottages or dorms for your guests. Clean, cozy, and nestled in nature—these stays make birthday events more relaxed and memorable."
  }
],




"services": [
  {
    "name": "Outdoor Birthday Party Venues Near Pune",
    "description": "Celebrate birthdays in a refreshing open-air farm setting at Anand Krushi Paryatan Kendra. Our outdoor venue, surrounded by mango orchards and green lawns, offers the perfect natural backdrop for birthdays of all ages—whether you want a casual get-together or a full festive setup with games and food."
  },
  {
    "name": "Farm Birthday Celebration Spots",
    "description": "Host a unique farm-style birthday party with rustic charm, bullock cart rides, traditional decorations, and rural games. Ideal for families wanting an offbeat experience close to nature—far from noisy city banquet halls."
  },
  {
    "name": "Kid-Friendly Birthday Setups",
    "description": "We offer child-friendly birthday environments with soft grass play areas, farm animals, swing sets, activity zones, and customizable party themes. Perfect for safe, exciting birthdays that kids will love and parents will appreciate."
  },
  {
    "name": "Nature-Based Birthday Party Places",
    "description": "Let nature be part of the celebration! Enjoy fresh air, trees, chirping birds, and open skies as part of your child’s or loved one's special day. Our venue is ideal for eco-conscious and peaceful celebrations in nature’s lap."
  },
  {
    "name": "Family Picnic Birthday Spots",
    "description": "Combine a birthday celebration with a relaxing family picnic. We provide shaded seating, mats, picnic meals, and optional party decorations—perfect for multi-generational gatherings with something for everyone to enjoy."
  },
  {
    "name": "Rural Theme Birthday Ideas",
    "description": "Celebrate with a twist! Opt for a rural theme birthday complete with mud art decor, sugarcane juice stalls, charpais, folk music, and traditional food. It’s both entertaining and educational for kids and adults alike."
  },
  {
    "name": "Open-Air Birthday Celebration Places",
    "description": "No walls, no limits. Celebrate in a beautiful open-air environment where kids can run freely, adults can relax under trees, and everyone can enjoy natural light and space. Ideal for morning to sunset parties."
  },
  {
    "name": "Birthday Games and Food Stalls",
    "description": "Add a carnival feel to your birthday with game stations, mango eating contests, sack races, and rural-style food stalls offering fresh bhakri, pakoras, and lemonade. We customize stalls as per age and preferences."
  },
  {
    "name": "Budget Birthday Packages",
    "description": "Affordable and value-packed, our birthday packages include entry, food, activity access, basic decorations, and more. We also offer custom options based on group size, preferences, and budget."
  },
  {
    "name": "Farm Lunch with Party Setup",
    "description": "Enjoy a wholesome Maharashtrian thali or customized menu as part of your birthday experience. Our farm lunch package includes outdoor seating, decorations, cake table, and serving support."
  },
  {
    "name": "Group Birthday Outings Near Pune",
    "description": "Planning a joint birthday or celebrating with a large group? We accommodate school groups, cousins, or friend circles with activity stations, open fields, food zones, and a stage for performances or announcements."
  },
  {
    "name": "Cake Cutting with Rural Décor",
    "description": "Make cake cutting memorable with traditional flower decorations, bullock cart setups, and clay decor. It's a picture-perfect moment that blends tradition and celebration beautifully."
  },
  {
    "name": "Fun Activity-Based Birthdays",
    "description": "Let kids and guests enjoy a birthday filled with meaningful fun—pottery, farming games, treasure hunts, birdwatching, and local storytelling sessions. It’s celebration + experience in one!"
  },
  {
    "name": "Pet-Friendly Party Venues",
    "description": "Bring along your furry friends! Our venue is pet-friendly and spacious, making it ideal for animal lovers who want their pets to be part of their special day. We can even arrange pet-themed party zones!"
  },
  {
    "name": "Picnic + Birthday Combo Options",
    "description": "Why choose one when you can have both? Celebrate with games, food, and cake, then relax with a family picnic. Our picnic + party combos are designed for full-day enjoyment without stress."
  }
],
"tableData": [
  ["Outdoor Birthday Party Venues Near Pune", "- Farm Birthday Celebration Spots"],
  ["Kid-Friendly Birthday Setups", "- Nature-Based Birthday Party Places"],
  ["Family Picnic Birthday Spots", "- Rural Theme Birthday Ideas"],
  ["Open-Air Birthday Celebration Places", "- Birthday Games and Food Stalls"],
  ["Budget Birthday Packages", "- Farm Lunch with Party Setup"],
  ["Group Birthday Outings Near Pune", "- Cake Cutting with Rural Décor"],
  ["Fun Activity-Based Birthdays", "- Pet-Friendly Party Venues"],
  ["Picnic + Birthday Combo Options", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Scenic Outdoor Birthday Venue",
    "WhyChoosedescription": "Morachi Chincholi provides a refreshing rural setting with open-air spaces, greenery, and natural beauty—making it a perfect backdrop for hosting memorable birthday parties away from the city's noise and crowds."
  },
  {
    "WhyChooseheading": "Fun Activities for All Ages",
    "WhyChoosedescription": "From bullock cart and tractor rides to rain dance, zip-lining, and farm games, birthday guests can enjoy a full day of entertainment. Both kids and adults will find exciting things to do throughout the celebration."
  },
  {
    "WhyChooseheading": "Custom Birthday Packages",
    "WhyChoosedescription": "Agro-tourism centers like Anand Krushi Paryatan Kendra offer affordable and customizable birthday packages that include decorations, food, games, and hosting support. Planning is made easy for parents or organizers."
  },
  {
    "WhyChooseheading": "Delicious Farm-Fresh Food",
    "WhyChoosedescription": "Guests are treated to traditional Maharashtrian meals made from fresh, local produce. Birthday menus can also be customized to include special treats and desserts, enhancing the culinary experience for attendees."
  },
  {
    "WhyChooseheading": "Safe and Spacious Environment",
    "WhyChoosedescription": "With large open areas, separate play zones for kids, and attentive staff, Morachi Chincholi venues ensure a secure and enjoyable environment—especially important when hosting events for families and young children."
  },
  {
    "WhyChooseheading": "Easily Accessible from Pune",
    "WhyChoosedescription": "Located just 50–60 km from Pune, Morachi Chincholi is ideal for a one-day birthday outing. The short travel distance makes it convenient for guests while offering a complete countryside party experience."
  }
]
























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Can I host a birthday party at Morachi Chincholi?',
    answer: 'Yes! Morachi Chincholi is a unique and refreshing location to host birthday parties, especially for kids and nature lovers, with open spaces and farm-based activities.',
  },
  {
    id: 'FAQ2',
    question: 'What kind of birthday party packages are available?',
    answer: 'Packages typically include venue access, decorations, food, games, rain dance, and activities like bullock cart rides and magic shows. Custom packages can be arranged based on your needs.',
  },
  {
    id: 'FAQ3',
    question: 'Is the venue suitable for both kids and adults?',
    answer: 'Absolutely. Kids love the open playgrounds, swings, and peacock sightings, while adults enjoy the peaceful rural ambiance and delicious food.',
  },
  {
    id: 'FAQ4',
    question: 'Do the birthday packages include meals?',
    answer: 'Yes, most venues offer traditional Maharashtrian meals as part of the package, along with birthday snacks or a custom food menu on request.',
  },
  {
    id: 'FAQ5',
    question: 'Can I bring my own cake and decorations?',
    answer: 'Yes, you’re allowed to bring your own cake and custom decorations, though some venues can also provide complete birthday décor and party supplies.',
  },
  {
    id: 'FAQ6',
    question: 'How many guests can be accommodated?',
    answer: 'Depending on the resort or farmstay, you can host small parties of 15–30 guests or larger celebrations with 100+ attendees.',
  },
  {
    id: 'FAQ7',
    question: 'Are indoor and outdoor options available?',
    answer: 'Yes. You can choose between shaded pavilions, open lawns, or indoor halls for your event depending on the season and group size.',
  },
  {
    id: 'FAQ8',
    question: 'Is entertainment included in the birthday party package?',
    answer: 'Entertainment like puppet shows, magic shows, DJ with rain dance, and traditional games are often included or can be added to your package.',
  },
  {
    id: 'FAQ9',
    question: 'How far is Morachi Chincholi from Pune for birthday party guests?',
    answer: 'Morachi Chincholi is around 60–65 km from Pune, which takes about 1.5 to 2 hours by road—perfect for a half-day or full-day celebration.',
  },
  {
    id: 'FAQ10',
    question: 'How can I book a birthday party at Morachi Chincholi?',
    answer: 'You can contact resorts like Anand Krushi Paryatan Kendra directly via phone or website to inquire about availability, pricing, and package customization.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Shweta Khandekar, Pune',
    feedback: "We hosted our son’s 7th birthday at Morachi Chincholi, and it was amazing! The kids had fun with the rain dance, peacocks, and farm games. Great rural experience!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Aniket Salvi, PCMC',
    feedback: "Loved the relaxed atmosphere and beautiful setup. Everything from the food to the decorations was handled perfectly. Highly recommend for outdoor birthday parties.",
    rating: 5,
  },
];


























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Birthday Party Hosting Morachi Chincholi Near Pune",
  "image": "https://morachichincholi.in/assets/images/birthday-party-morachi-chincholi.jpg",
  "description": "Host outdoor and nature-based birthday parties near Pune at Morachi Chincholi with farm venues, kid-friendly setups, rural themes, fun activities, picnic combos, pet-friendly spaces, and budget party packages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "642"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/birthday-party-hosting"
  }
};




    return (
        <div>
<Helmet>
  <title>Birthday Party Hosting Morachi Chincholi Near Pune | Outdoor & Farm Venues</title>
  <meta 
    name="description" 
    content="Celebrate birthday parties near Pune at Morachi Chincholi with outdoor farm venues, kid-friendly setups, rural themes, fun games, picnic combos, pet-friendly spaces, and affordable packages." 
  />
  <meta 
    name="keywords" 
    content="Outdoor birthday party venues near Pune, Farm birthday celebration spots, Kid-friendly birthday setups, Nature-based birthday party places, Family picnic birthday spots, Rural theme birthday ideas, Open-air birthday celebration places, Birthday games and food stalls, Budget birthday packages, Farm lunch with party setup, Group birthday outings near Pune, Cake cutting with rural décor, Fun activity-based birthdays, Pet-friendly party venues, Picnic + birthday combo options" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Birthdaypartyhoisting;